import type { IPswFeedbackErrorMessage } from '@/types';

export const COGNITO_ERRORS: Record<string, string> = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  UserNotFoundException: 'COGNITO.USER_NOT_FOUND',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  NotAuthorizedException: 'COGNITO.NOT_AUTHORIZED',
};

export const pswFeedbackErrors: IPswFeedbackErrorMessage[] = [
  {
    message: 'ERRORS.PSW_FEEDBACK.MINLENGTH',
    errorType: 'minLength',
  },
  {
    message: 'ERRORS.PSW_FEEDBACK.UPPER_LETTER',
    errorType: 'hasUpperLetter',
  },
  {
    message: 'ERRORS.PSW_FEEDBACK.SPECIAL_CHAR',
    errorType: 'hasSpecialChar',
  },
  {
    message: 'ERRORS.PSW_FEEDBACK.ONE_DIGIT',
    errorType: 'hasDigits',
  },
];

export const ERRORS = {
  empty: 'ERRORS.EMPTY',
  email: 'ERRORS.INVALID_EMAIL',
  phoneNumber: 'ERRORS.INVALID_PHONE',
  invalidCode: 'ERRORS.INVALID_CODE',
  invalidFiscalCode: 'ERRORS.INVALID_FISCALCODE',
  invalidField: 'ERRORS.INVALID_FIELD',
  invalidNumber: 'ERRORS.INVALID_NUMBER',
  invalidBatchValue: 'ERRORS.INVALID_BATCHVALUE',
  invalidCoupon: 'ERRORS.INVALID_COUPON',
  invalidFileSize: 'ERRORS.INVALID_FILE_SIZE',
  invalidFileType: 'ERRORS.INVALID_FILE_TYPE',
};
